import { useLanguage } from '../context/LanguageContext';

export default function ImpressumPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[hsl(38,44%,96%)]">
      <section className="bg-[hsl(20,17%,12%)] text-white py-16 sm:py-20">
        <div className="mx-auto max-w-[72rem] px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-[family-name:var(--font-display)] text-3xl sm:text-4xl lg:text-5xl tracking-[var(--tracking-display)]">{t('impressum')}</h1>
        </div>
      </section>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl p-6 sm:p-8 border border-[hsl(32,17%,84%)] space-y-8">
          <div>
            <h2 className="font-[family-name:var(--font-display)] text-xl mb-4">Angaben gemäß § 5 TMG</h2>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed">
              Ermal Sinanaj<br />
              Little Italy Ristorante<br />
              Alter Markt 6<br />
              69412 Eberbach<br />
              Deutschland
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">Kontakt</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed">
              Telefon: 0179 / 700 79 58<br />
              E-Mail: info@little-italy-ristorante.de
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">Verantwortlich für den Inhalt gemäß § 55 Abs. 2 RStV</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed">
              Ermal Sinanaj<br />
              Alter Markt 6<br />
              69412 Eberbach
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">Haftung für Inhalte</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">Haftung für Links</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">Urheberrecht</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
          </div>

          <div>
            <h3 className="font-[family-name:var(--font-display)] text-lg mb-3">Streitschlichtung</h3>
            <p className="text-[hsl(22,10%,38%)] leading-relaxed text-sm">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
